import axios from 'axios'

const apiService = {
  getAddressSuggestions: async (input, sessionToken) => {
    try {
      const { data: { data } } = await axios.get(`${process.env.REACT_APP_API_URL}/api/c2/addresses/autocomplete?input=${input}`, { headers: { 'device-id': sessionToken } })
      return data
    } catch (error) {
      throw error
    }
  },
  getGeolocation: async (placeid, sessionToken) => {
    try {
      const { data: { data } } = await axios.get(`${process.env.REACT_APP_API_URL}/api/c2/addresses/details?placeid=${placeid}`, { headers: { 'device-id': sessionToken } })
      return data
    } catch (error) {
      throw error
    }
  },
  getEstimation: async (waypoints) => {
    const payload = {
      order: {
        details: {
          vehicle_type: '',
          rent_hours: '0',
          coupons: '',
          additional_requirements: {
            passenger_count: 0,
            cart_count: 0,
            mover_count: 0,
            forklift_count: 0,
            goods_longer_than_6ft: false,
            goods_taller_than_2ft: false,
            need_access_restricted_area: false,
            need_english_driver: false,
            need_pet_transportation: false,
            need_new_car: false,
            need_dump_waste: false,
            need_refrigeration: false,
            need_covered_lorry: false,
            need_tailgate: false,
            tollway: ''
          },
          contact_info: {},
          recipient_info: {},
          driver_info: {},
          note_to_driver: '',
          free_waiting_time: 0,
          scheduled: false,
          enable_order_receipt: false,
          waypoints,
        },
        payment: {
          base_quote: '',
          tip: '',
          additional_fees: {
            passenger_count: '0',
            cart_count: '0',
            mover_count: '0',
            forklift_count: '0',
            goods_longer_than_6ft: '0',
            goods_taller_than_2ft: '0',
            need_access_restricted_area: '0',
            need_english_driver: '0',
            need_pet_transportation: '0',
            need_new_car: '0',
            need_dump_waste: '0',
            need_refrigeration: '0',
            need_covered_lorry: '0',
            need_tailgate: '0',
            tollway: '0',
            need_delivery_box: '0'
          },
          surcharges: {
            special_pricing_day: '0',
            holiday_extra_charge: '0',
            night_extra_charge: '0',
            midnight_extra_charge: '0'
          },
          total: '0'
        },
        meta: {}
      }
    }
    try {
      const { data: { data } } = await axios.post(`${process.env.REACT_APP_API_URL}/api/c2/orders/quote`, payload)
      return data
    } catch (error) {
      throw error
    }
  },
  getCourierEstimation: async (payload) => {
    const order = {
      shipper: {
        longitude: payload.shipperLongitude,
        latitude: payload.shipperLatitude
      },
      pickup_time: new Date(),
      recipient: {
        longitude: payload.recipientLongitude,
        latitude: payload.recipientLatitude
      },
      length: "40",
      height: "40",
      width: "40",
      delivery_quotation_type: "instant"
    }
    try {
      const { data: { data } } = await axios.post(`${process.env.REACT_APP_GGD_API_URL}/api/c3/orders/quote`, order)
      return data
    } catch (error) {
      throw error
    }
  }
}

export { apiService }
